import { FC } from "react";
import { VoidFunc } from "../../../helpers/functions/types";
import { SwitchAtom } from "./atoms/SwitchAtom";
import { Disabled } from "../../../components/Disabled";
import { CommonInputControlsProps } from "./types";
import { NAMED_NARROW_INPUT_STYLES, NAMED_WRAPPER_STYLES } from "./constants";
import { LabelAtom } from "./atoms/LabelAtom";

type NamedSwitchProps = CommonInputControlsProps<
  boolean,
  VoidFunc<boolean> | undefined
>;

export const NamedSwitch: FC<React.PropsWithChildren<NamedSwitchProps>> = ({
  title,
  subtitle,
  className,
  value,
  onChange,
  permissions,
  styleVariant = "slideOver",
  customId,
  disabled,
}) => {
  const switchId = customId ?? `${title}Toggle`;

  const SwitchNode = (
    <SwitchAtom
      name={switchId}
      className="justify-self-end"
      checked={value}
      onChange={onChange}
      disabled={disabled}
    />
  );

  return (
    <div className={className ?? "px-4"} onClick={(e) => e.stopPropagation()}>
      <div
        className={`${NAMED_WRAPPER_STYLES} ${subtitle?.length ? "h-16" : NAMED_NARROW_INPUT_STYLES[styleVariant]}`}
      >
        <LabelAtom
          title={title}
          htmlFor={switchId}
          subtitle={subtitle}
          srOnly={styleVariant === "srLabel"}
          narrowInput={true}
        />
        {(onChange || customId) &&
          (permissions ? (
            <Disabled editPermissions={permissions}>{SwitchNode}</Disabled>
          ) : (
            SwitchNode
          ))}
      </div>
    </div>
  );
};
